// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"954":"086fdbed","4271":"6be07158","5652":"422c8b63","9120":"31c82aaa"}[chunkId] + ".chunk.css";
};